import React from 'react';
import { connect } from 'dva';

import {component_tool,framework_tool} from '../../../tool'
let {WizAffix,WizSteps, WizTree, WizTabs,} = component_tool;
let { WizContainer,WizLayoutTemplate } = framework_tool;
import 'antd/dist/antd.css';

const { Step } = WizSteps;

const { TreeNode } = WizTree;

const { TabPane } = WizTabs


class TemplateDemo extends WizContainer {

  componentName = 'TemplateDemo';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  /**
  * 页脚
  */
  footer_setting = () => {
    return {
      name: 'WizSteps',
      params: {
        style: { width: 800 },
        current: 1,
        status: "error",
        children: [
          <Step title="我是页脚" description="我是页脚部分Footer" />,
          <Step title="In Process" description="This is a description" />,
          <Step title="Waiting" description="This is a description" />
        ]
      }
    }
  }

  /**
   * 侧边栏
   */
  sider_setting = () => {
    return {
      name: 'WizTree',
      params: {
        showLine: true,
        style: { backgroundColor: '#ffffff' },
        defaultExpandedKeys: ['0-0-0'],
        children: (
          <TreeNode title="parent 1" key="0-0">
            <TreeNode title="parent 1-0" key="0-0-0">
              <TreeNode title="leaf" key="0-0-0-0" />
              <TreeNode title="leaf" key="0-0-0-1" />
              <TreeNode title="leaf" key="0-0-0-2" />
              <TreeNode title="leaf" key="0-0-0-4" />
              <TreeNode title="leaf" key="0-0-0-5" />
              <TreeNode title="leaf" key="0-0-0-6" />
            </TreeNode>
            <TreeNode title="parent 1-1" key="0-0-1">
              <TreeNode title="leaf" key="0-0-1-0" />
              <TreeNode title="leaf" key="0-0-1-1" />
              <TreeNode title="leaf" key="0-0-1-2" />
            </TreeNode>
            <TreeNode title="parent 1-2" key="0-0-2">
              <TreeNode title="leaf" key="0-0-2-0" />
              <TreeNode title="leaf" key="0-0-2-1" />
            </TreeNode>
          </TreeNode>
        )
      }
    }
  }

  /**
   * 主要内容
   */
  content_setting = () => {
    return {
      name: 'WizTabs',
      params: {
        className: 'full-layout page',
        style: { backgroundColor: 'white' },
        defaultActiveKey: "2",
        children: [
          <TabPane tab="Tab 1" key="1">
            Content of tab 1
          </TabPane>,
          <TabPane tab="Tab 2" key="2">
            Content of tab 2
          </TabPane>,
          <TabPane tab="Tab 3" key="3">
            Content of tab 3
          </TabPane>
        ]
      }
    }
  }



  header_setting = () => {
    return {
      name: 'WizPageHeader',
      params: {
        title: '通用模版示例',
        subTitle: "这是一个使用示例"
      }
    }
  }

  /**
   * 总体配置
   */
  setting = () => {
    return {
      componentName: 'TemplateDemo',
      header: this.header_setting(),
      content: this.content_setting(),
      footer: this.footer_setting(),
      //sider: this.sider_setting()
    }
  }



  _render() {
    return <WizLayoutTemplate {...this.setting()} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TemplateDemo);
